import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '@/lib/api';

export const useAuthStore = create(persist((set) => ({
  user: null,
  loading: true,
  init: async () => {
    set({ loading: true });
    try {
      const r = await api.get('/auth/me');
      set({ user: r.data?.user || null, loading: false });
    } catch (err) {
      console.error('Failed to init auth:', err);
      set({ user: null, loading: false });
    }
  },
  setUser: (user) => set({ user }),
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (err) {
      console.error('Failed to logout cleanly:', err);
    }
    set({ user: null });
  },
}), { name: 'memoir_auth_v1', partialize: (s) => ({ user: s.user }) }));

export const useThemeStore = create(persist((set, get) => ({
  theme: 'light',
  setTheme: (theme) => {
    set({ theme });
    if (typeof document !== 'undefined') {
      if (theme === 'dark') document.documentElement.classList.add('dark');
      else document.documentElement.classList.remove('dark');
    }
  },
  toggleTheme: () => {
    const next = get().theme === 'dark' ? 'light' : 'dark';
    set({ theme: next });
    if (typeof document !== 'undefined') {
      if (next === 'dark') document.documentElement.classList.add('dark');
      else document.documentElement.classList.remove('dark');
    }
  },
}), { name: 'memoir_theme_v1' }));
